﻿import { setGeoData } from "./geoData";
import { isNullOrEmpty } from "./isNullOrEmpty";
import { loadFullPage } from "./loadFullPage";

const _chaveSessionUsuarioLogado = 'usuarioLogado';

export async function carregarUsuarioLogado() {

    const carregarModalDownloadCurriculo = () => {
        async function abrirModal(url) {
            try {
                loadFullPage.mostrar();
                // Busca a partial
                const resp = await fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } });
                const html = await resp.text();

                // Remove modal antigo (se houver)
                const antigo = document.getElementById("baixar-curriculo");
                if (antigo) antigo.remove();

                // Insere no body
                document.body.insertAdjacentHTML("beforeend", html);

                // Seleciona o modal inserido
                const modalEl = document.getElementById("baixar-curriculo");

                // Inicializa e mostra
                const modal = new bootstrap.Modal(modalEl);
                loadFullPage.esconder();

                modal.show();
            } catch (err) {
                loadFullPage.esconder();
                console.error(err);
                alert("Erro ao carregar modal");
            }
        }

        const btnsBaixarCurriculo = document.querySelectorAll(".baixar-curriculo");

        if(btnsBaixarCurriculo && btnsBaixarCurriculo.length > 0){

            btnsBaixarCurriculo.forEach(btn => {
                btn.addEventListener('click', () => { 
                    console.log('aqui');
                    abrirModal(`/${CULTURE_EMPREGARE}/PainelNotificacoes/BaixarCurriculoModal`);
                });
            }, { once: true });
        }
    };

    const _mudarLayoutLogado = function (resposta) {
        
        const headerLogado = document.getElementById('header-candidato-logado');
        const menuLogadoOculto = document.getElementById('menu-logado-oculto');
        const outrosMenusNaoLogado = document.querySelector('.menu-nao-logado');
        const sideBarCandidato = document.querySelector('.container-side-bar-candidato');
        const hotsite = document.querySelector("#layout-hotsite");
        const hotsiteHomePageCustom= document.querySelector("#hotsite-home-page-custom");
        const headerQuestionario = document.querySelector(".header-questionario");
        const estaNaPaginaAcelereSuaCarreira = document.getElementById('pagina-acelere-sua-carreira');
        const navEmployerPage = document.querySelector("#nav-sticker");


        //mostrar stick footer
        document.getElementById('stick-footer-candidato-logado').classList.remove("d-none");
        const footerEmpregare = document.getElementById('footer-empregare');
        if (document.contains(footerEmpregare)) {
            footerEmpregare.classList.add('mb-5', 'mb-md-0', 'pb-4', 'pb-md-0');
        }

        if (sideBarCandidato && !hotsiteHomePageCustom && !headerQuestionario && !estaNaPaginaAcelereSuaCarreira){
            sideBarCandidato.classList.add('d-lg-block');

            if(navEmployerPage)
                navEmployerPage.classList.add("tab-fixed-top-logado");
        }

        if (menuLogadoOculto !== null) {
            //mostrar menu logado
            menuLogadoOculto.classList.remove("d-none");
        }

        if (outrosMenusNaoLogado !== null) {
            //esconder outro menu
            document.querySelector('.menu-nao-logado').classList.add('d-none');
        }

        // Mudancas para caso logar em hotsite

        if (hotsite) {
            let eventoLoginHostite = new CustomEvent("LoginHotsite");
            dispatchEvent(eventoLoginHostite);
        }

        const fotoCandidato = headerLogado.querySelectorAll(".img-perfil");
        fotoCandidato.forEach((item) => {
            item.src = resposta.foto;
        });

        const nomeCandidato = headerLogado.querySelectorAll(".header-nome-candidato");
        nomeCandidato.forEach((item) => {
            item.innerHTML = resposta.nome;
        });

        const numeroMensagens = document.querySelectorAll('.menu-mensagens-numero');
        numeroMensagens.forEach((item) => {            
            if (resposta.mensagens > 0) {
                item.innerHTML = resposta.mensagens;
                item.classList.remove('d-none');
            }
            
        });

        const numeroNotificacoes = document.querySelectorAll('.menu-noficacoes-numero');
        numeroNotificacoes.forEach((item) => {
            if (resposta.notificacoes > 0) {
                item.innerHTML = resposta.notificacoes;
                item.classList.remove('d-none');
            }
        });

        const curriculoProgressoContainer = document.querySelectorAll('.curriculo-progesso-numero');
        curriculoProgressoContainer.forEach((item) => {
            item.innerHTML = resposta.curriculoProgresso + "%";
            item.classList.remove('d-none');
        });

        const itensCodigoUsuario = document.querySelectorAll('.codigo-usuario-logado');
        itensCodigoUsuario.forEach((item) => {
            item.querySelector("b").innerHTML = resposta.id;
        });

        const linkLogoHeader = document.querySelector("#header-candidato-logado").querySelector(".imagem-link");

        if(linkLogoHeader && !hotsite)
            linkLogoHeader.href = `/${CULTURE_EMPREGARE}/candidato/painel`;

        // Tela vagas

        const espacamento = document.querySelector(".espacamento-para-menu-lateral");
        if(espacamento)
            espacamento.classList.add("d-lg-block");

        const barraPesquisa = document.querySelector(".pesquisa-cargo-hotsite");
        if(barraPesquisa)
            barraPesquisa.classList.add("pesquisa-cargo-hotsite-logado");


        carregarModalDownloadCurriculo();
    }

    const _fetchDados = async function () {
        await fetch(`/${CULTURE_EMPREGARE}/Login/GetUsuarioLogado`)
            .then(response => response.json())
            .then(async resposta => {
                sessionStorage.setItem(_chaveSessionUsuarioLogado, JSON.stringify(resposta));

                setGeoData(resposta.geoData);

                if (!resposta.logado) {
                    const { googleLogin } = await import('../componentes/googleLogin');
                    await googleLogin.init();
                    const scriptGoogle = document.getElementById('google-gsi-client-script');
                    // areas do ATS nao podem ter one tap
                    if (isNullOrEmpty(scriptGoogle.dataset.empresa) || scriptGoogle.dataset.empresa == 'False') {
                        document.dispatchEvent(new CustomEvent('solicitarGoogleLoginOneTap'));
                    }

                    return;
                }
                _mudarLayoutLogado(resposta);                
            });
    };


    const sessionLogado = sessionStorage.getItem(_chaveSessionUsuarioLogado);

    if (!sessionLogado) {
        await _fetchDados();
        return;
    }

    const logadoJson = JSON.parse(sessionLogado);

    if (!logadoJson.logado) {
        const { googleLogin } = await import('../componentes/googleLogin');
        await googleLogin.init();
        const scriptGoogle = document.getElementById('google-gsi-client-script');
        // areas do ATS nao podem ter one tap
        if (isNullOrEmpty(scriptGoogle.dataset.empresa) || scriptGoogle.dataset.empresa == 'False') {
            document.dispatchEvent(new CustomEvent('solicitarGoogleLoginOneTap'));
        }
        
        return;
    }
    _mudarLayoutLogado(logadoJson);
    
}

export async function getUsuarioLogadoViaServidor() {
    try {
        const request = await fetch(`/${CULTURE_EMPREGARE}/Login/GetUsuarioLogado`);
        const response = await request.json();
        return response;
    }
    catch (error) {
        console.error(error);
        return null;
    }
}

export function getUsuarioLogado() {
    const sessionLogado = sessionStorage.getItem(_chaveSessionUsuarioLogado);

    if (!sessionLogado) {
        return null;
    }

    return JSON.parse(sessionLogado);
}

export function removeCacheUsuarioLogado() {
    if (sessionStorage.getItem(_chaveSessionUsuarioLogado)) {
        sessionStorage.removeItem(_chaveSessionUsuarioLogado);
    }
}